if (!customElements.get('nyvolt-yvolt')) {
  customElements.define('nyvolt-yvolt', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.hero = this.querySelector('#YvoltHero');
      this.variants = Array.from(this.querySelectorAll('[data-yv-variant]'));
      this.photos = Array.from(this.querySelectorAll('[data-yv-photo]'));
      this.addEventListener('click', event => {
        const variant = event.target.closest('[data-yv-variant]');
        if (variant) this.chooseVariant(variant, true);
        const photo = event.target.closest('[data-yv-photo]');
        if (photo) this.showPhoto(photo);
        const step = event.target.closest('[data-yv-step]');
        if (step) this.step(Number(step.dataset.yvStep));
      });
      const stage = this.querySelector('.yv-gallery__main');
      stage?.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.onPopState = () => {
        const id = new URL(location.href).searchParams.get('variant');
        this.chooseVariant(this.variants.find(v => v.dataset.yvVariant === id) || this.variants[0], false);
      };
      window.addEventListener('popstate', this.onPopState);
      this.chooseVariant(this.variants.find(v => v.getAttribute('aria-pressed') === 'true') || this.variants[0], false);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPopState); this.ready = false; }
    chooseVariant(variant, updateURL) {
      if (!variant) return;
      this.variants.forEach(button => button.setAttribute('aria-pressed', String(button === variant)));
      this.querySelector('[data-yv-colour-label]').textContent = variant.dataset.label;
      this.photos.forEach(photo => { photo.hidden = photo.dataset.colour !== 'all' && photo.dataset.colour !== variant.dataset.colour; });
      this.showPhoto(this.photos.find(photo => !photo.hidden), updateURL);
      const available = variant.dataset.available === 'true';
      const addButton = this.querySelector('[data-yv-add]');
      this.querySelector('[data-yv-order-variant]').value = variant.dataset.yvVariant;
      this.querySelector('[data-yv-price]').textContent = variant.dataset.price;
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.unavailableLabel;
      this.querySelectorAll('[data-yv-contact]').forEach(link => {
        const url = new URL(this.dataset.contact, location.origin);
        url.searchParams.set('modele', this.dataset.title);
        url.searchParams.set('coloris', variant.dataset.label);
        link.href = url.pathname + url.search;
      });
      if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', variant.dataset.yvVariant); history.replaceState({}, '', url); }
    }
    showPhoto(photo, prioritize = true) {
      if (!photo || !this.hero) return;
      if (prioritize) { this.hero.loading = 'eager'; this.hero.fetchPriority = 'high'; }
      this.hero.srcset = photo.dataset.srcset;
      this.hero.src = photo.dataset.src;
      this.hero.alt = photo.dataset.alt;
      this.photos.forEach(button => button.setAttribute('aria-pressed', String(button === photo)));
      const visible = this.photos.filter(button => !button.hidden);
      const counter = this.querySelector('[data-yv-count]');
      if (counter) counter.textContent = String(visible.indexOf(photo) + 1).padStart(2, '0') + ' / ' + String(visible.length).padStart(2, '0');
      const caption = this.querySelector('[data-yv-caption]');
      if (caption) caption.textContent = photo.dataset.alt || '';
      this.querySelectorAll('[data-yv-step]').forEach(button => { button.disabled = visible.length < 2; });
    }
    step(direction) {
      const visible = this.photos.filter(photo => !photo.hidden);
      if (!visible.length) return;
      const current = visible.findIndex(photo => photo.getAttribute('aria-pressed') === 'true');
      this.showPhoto(visible[(current + direction + visible.length) % visible.length]);
    }
  });
}

